import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

/**
 * Bulk product upload (Phase 8, optional): Excel template per category → upload (sheet or ZIP with images) →
 * check → import → approval. Admin: `catalog.bulk_upload`; vendors also need `catalog.vendor_bulk_upload`.
 */
export const bulkuploadModule = defineModule({
  name: "bulkupload",
  label: "Bulk product upload",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "medialib",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
    "products",
  ],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "bulk-upload",
        permission: "products.view_product",
        feature: "catalog.bulk_upload",
        page: () => import("./admin/BulkUploadPage"),
      },
      {
        path: "bulk-upload/:uid",
        permission: "products.view_product",
        feature: "catalog.bulk_upload",
        page: () => import("./admin/BatchPage"),
      },
    ],
    nav: [
      {
        id: "bulk-upload",
        group: "catalog",
        label: "bulkupload:nav.bulkUpload",
        icon: "upload",
        to: "/bulk-upload",
        permission: "products.view_product",
        feature: "catalog.bulk_upload",
        order: 7,
      },
    ],
  },
  vendor: {
    routes: [
      {
        path: "bulk-upload",
        permission: "products.manage",
        feature: "catalog.vendor_bulk_upload",
        page: () => import("./vendor/BulkUploadPage"),
      },
      {
        path: "bulk-upload/:uid",
        permission: "products.manage",
        feature: "catalog.vendor_bulk_upload",
        page: () => import("./vendor/BatchPage"),
      },
    ],
    nav: [
      {
        id: "bulk-upload",
        group: "catalog",
        label: "bulkupload:nav.bulkUpload",
        icon: "upload",
        to: "/bulk-upload",
        permission: "products.manage",
        feature: "catalog.vendor_bulk_upload",
        order: 20,
      },
    ],
  },
});
